// faviconBadge.js
// Single writer for the browser-tab favicon badge. Named sources report their
// current counts here; we render exactly one badge by priority (see pickBadge),
// so the inbox/support/open sources never clobber each other.
//
// The `sources` object is this module's own private render state (same category
// as the mutable module state already in tab-badge.js) — not shared business data.
import { setFaviconBadge } from './tab-badge';
import { setFaviconBadgeFirefox } from './tab-badge-firefox';
import { pickBadge } from './faviconBadgePick';

const sources = { inbox: 0, support: 0, supportOpen: 0 };

const render = () => {
    const { count, color } = pickBadge(sources);
    const opts = color ? { badgeColor: color } : {};
    setFaviconBadge(count, opts);
    setFaviconBadgeFirefox(count, opts);
};

// name: 'inbox' | 'support' | 'supportOpen'
export const setFaviconSource = (name, count) => {
    if (!(name in sources)) return;
    const n = Number(count) || 0;
    if (sources[name] === n) return; // nothing changed for this source
    sources[name] = n;
    render();
};
